import React from "react";

import { Card } from "components";

export type OutlinedCardProps = {
  children?: React.ReactNode;
  className?: string;
  dataTestId?: string;
};

export const OutlinedCard: React.FC<OutlinedCardProps> = ({ children, className = "", dataTestId = "" }) => (
  <Card dataTestId={dataTestId} className={`outlined-card padding-150 ${className}`}>
    {children}
  </Card>
);
